import { render } from "./workersAcc.vue?vue&type=template&id=1fcd4970"
import script from "./workersAcc.vue?vue&type=script&lang=js"
export * from "./workersAcc.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__